import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconCoffee(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-coffee_svg__stroke",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M23,12V12a4,4,0,0,0,1.3,2.67,1,1,0,0,0,1.4-1.42A2.5,2.5,0,0,1,25,12.12a11.58,11.58,0,0,1,.87-1.61A6.45,6.45,0,0,0,27,8.06a3.92,3.92,0,0,0-1.3-2.77,1,1,0,1,0-1.4,1.42A2.61,2.61,0,0,1,25,7.88a13,13,0,0,1-.87,1.61A6.23,6.23,0,0,0,23,12Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M21.71,14.7a1,1,0,0,0,0-1.41A2.61,2.61,0,0,1,21,12.12a11.58,11.58,0,0,1,.87-1.61A6.41,6.41,0,0,0,23,8.05a3.91,3.91,0,0,0-1.3-2.76,1,1,0,1,0-1.4,1.42A2.61,2.61,0,0,1,21,7.88a13,13,0,0,1-.87,1.61A6.28,6.28,0,0,0,19,11.94V12a4,4,0,0,0,1.3,2.67A1,1,0,0,0,21.71,14.7Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M34,45H11a1,1,0,0,0,0,2H34a1,1,0,0,0,0-2Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M39,20H35V18a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V34a9,9,0,0,0,9,9h8c4.41,0,7.57-3.24,8-8h4a3,3,0,0,0,3-3V23A3,3,0,0,0,39,20ZM33,34c0,3.49-1.85,7-6,7H19a7,7,0,0,1-7-7V19H33Zm7-2a1,1,0,0,1-1,1H35V22h4a1,1,0,0,1,1,1Z"
      }));
    }
  }));
}
export default SvgIconCoffee;